var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "28 658 21 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M47.78,664.8c-.02-.2-.19-.36-.39-.37-.05,0-5.04-.23-8.18-4.17-.03-.03-.07-.05-.1-.07-.03-.02-.05-.05-.08-.06,0,0,0,0-.01,0-.04-.01-.09,0-.13,0-.04,0-.08,0-.12,0,0,0,0,0-.01,0-.04.01-.06.04-.09.06-.03.02-.07.03-.1.07-3.15,3.94-8.13,4.17-8.17,4.17-.21,0-.39.16-.41.37-.22,2.55-.12,4.72.19,6.59h.8c-.3-1.74-.4-3.78-.22-6.18,1.18-.13,4.9-.76,7.71-3.63v9.8h9.11c.32-1.86.42-4.04.19-6.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M39.3,681.19v-9.8h-9.11c1.57,9.24,8.54,10.71,8.63,10.73.03,0,.05,0,.08,0s.05,0,.08,0c.08-.02,7.06-1.49,8.63-10.73h-.8c-1.25,7.29-5.94,9.32-7.49,9.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldKey);
export default __webpack_public_path__ + "static/media/shield-key.dae4a356aa492933061106fa1c0e0c8c.svg";
export { ForwardRef as ReactComponent };